export const getOrder = orderId => ({
  type: 'GET_ORDER_CONFIRMATION',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'get',
      url: `/v1/purchases/${orderId}/order`
    }
  }
})

export default {
  getOrder
}



// WEBPACK FOOTER //
// ./src/features/Services/ConfirmationCreditMileage/actions.js